import { IProcess } from '../../../../Types/ProcessModel';
import EDGrid from '../../../../BaseComponents/GridComponents/EDGrid';
import EDPanel from '../../../../BaseComponents/Panel/EDPanel';
import EDTypography from '../../../../BaseComponents/Typography/EDTypography';
import { ProcessModel } from '../../../../Model/ProcessModel/ProcessModel';
import EDButton from '../../../../BaseComponents/Buttons/Button/EDButton';

interface IProps {
  onProcessSelected: (process: IProcess) => void;
}

/**
 * En vy där olika typer av processer listas upp och kan väljas
 */
export const SelectProcessPage = (props: IProps) => {
  return (
    <EDGrid container item xs={12} justifyContent="center" spacing={2}>
      <EDGrid item xs={8}>
        <EDPanel>Styrprocesser</EDPanel>
      </EDGrid>
      <EDGrid item xs={8}>
        <EDPanel>Kärnprocesser</EDPanel>
      </EDGrid>
      <EDGrid item xs={8}>
        <EDPanel>
          <EDTypography variant="subtitle1">Stödprocesser</EDTypography>
          <div>
            {/* Todo: select processes based on type (Styrprocesser, Kärnprocesser, Stödprocesser) */}
            {ProcessModel.Processer.map((x: IProcess) => (
              <EDButton
                key={x.Kod + x.Benamning}
                label={x.Kod + '. ' + x.Benamning}
                onClick={() => props.onProcessSelected(x)}
              />
            ))}
          </div>
        </EDPanel>
      </EDGrid>
    </EDGrid>
  );
};
